import Projektprognos from './Projektprognos'
import styles from './ProjektprognosWrappers.module.css'
import { ProjektprognosEditingContextProvider } from './context/ProjektprognosEditingContext'
import { ProjektprognosSheetContextProvider } from './context/ProjektprognosSheetContext'
import { ProjektprognosInteractionContextProvider } from './context/ProjektprognosInteractionContext'
import { InteractionContextProvider } from '../../context/InteractionContext'

const ProjektprognosWrappers = () => (
  <InteractionContextProvider>
    <ProjektprognosInteractionContextProvider>
      <ProjektprognosEditingContextProvider>
        <ProjektprognosSheetContextProvider>
          <div className={styles.projektprognosWrappers}>
            <Projektprognos />
          </div>
        </ProjektprognosSheetContextProvider>
      </ProjektprognosEditingContextProvider>
    </ProjektprognosInteractionContextProvider>
  </InteractionContextProvider>
)

export default ProjektprognosWrappers
